function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var throttleit;
var hasRequiredThrottleit;

function requireThrottleit () {
	if (hasRequiredThrottleit) return throttleit;
	hasRequiredThrottleit = 1;
	function throttle(function_, wait) {
		if (typeof function_ !== 'function') {
			throw new TypeError(`Expected the first argument to be a \`function\`, got \`${typeof function_}\`.`);
		}

		// TODO: Add `wait` validation too in the next major version.

		let timeoutId;
		let lastCallTime = 0;

		return function throttled(...arguments_) { // eslint-disable-line func-names
			clearTimeout(timeoutId);

			const now = Date.now();
			const timeSinceLastCall = now - lastCallTime;
			const delayForNextCall = wait - timeSinceLastCall;

			if (delayForNextCall <= 0) {
				lastCallTime = now;
				function_.apply(this, arguments_);
			} else {
				timeoutId = setTimeout(() => {
					lastCallTime = Date.now();
					function_.apply(this, arguments_);
				}, delayForNextCall);
			}
		};
	}

	throttleit = throttle;
	return throttleit;
}

var throttleitExports = /*@__PURE__*/ requireThrottleit();
var throttle = /*@__PURE__*/getDefaultExportFromCjs(throttleitExports);

/**
 * The message type sent to the Suite parent window when user activity is detected.
 * Consumers should use this constant to listen for activity events.
 */
var USER_ACTIVITY_DETECTED = "USER_ACTIVITY_DETECTED";
/**
 * Relays a user activity event to the Suite parent window if running inside an iframe.
 * Posts a message of type USER_ACTIVITY_DETECTED to the Suite parent.
 * This function is throttled to avoid excessive postMessage calls.
 * @param win Optional window object to use instead of the global window.
 */
var relayUserActivityToSuite = throttle(function (win) {
    var targetWindow = win || window;
    // Only post if inside an iframe and postMessage is available
    if (targetWindow.parent !== targetWindow && typeof targetWindow.parent.postMessage === "function") {
        targetWindow.parent.postMessage({
            type: USER_ACTIVITY_DETECTED,
            source: "suite-iframe-activity-relay"
        }, "*");
    }
}, 1000);

export { USER_ACTIVITY_DETECTED, relayUserActivityToSuite };
//# sourceMappingURL=index.esm.js.map
